import classnames from 'classnames';
import { Link, LinkProps, useParams } from 'react-router-dom';
import { ChevronIcon, Flex, Heading } from 'yoso';
import { HelpArticleModel, HelpCategoryModel } from '~/components/Help/Help.hooks';
import { RouteLocationState } from '~/components/Route/Route.hooks';
import './HelpCategoryItem.scss';

export type HelpCategoryItemProps = HelpArticleModel & Pick<HelpCategoryModel, 'categoryId'>;

export const HelpCategoryItem = ({ id, title, body, categoryId }: HelpCategoryItemProps) => {
  const { documentId } = useParams<{ documentId: string }>();
  const active = +documentId === id;
  const to = active
    ? `/support/help/category/${categoryId}/document`
    : `/support/help/category/${categoryId}/document/${id}`;

  return (
    <div className={classnames('help-category-item', { active })}>
      <Flex<LinkProps<RouteLocationState>>
        as={Link}
        className="help-category-item-header"
        container
        alignItems="center"
        to={{
          pathname: to,
          state: {
            preventScrollRestoration: true,
          },
        }}
        replace>
        <Flex flex={1}>
          <Heading
            level={6}
            className="help-category-item-title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </Flex>
        <Flex>
          <ChevronIcon />
        </Flex>
      </Flex>
      <div className="help-category-item-body">
        <div className="help-category-item-content" dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </div>
  );
};
